const FormattedNumber: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <>{children ? children.toLocaleString('en-US') : 0}</>
}

export default FormattedNumber
